// extracted by mini-css-extract-plugin
export default {"maindiv":"Sop_maindiv__jMgqf"};